import { BigFormRow, MediumFormRow, FormRow } from 'framework/ui/layout';
import { useMemo } from 'react';
import {
  AVAILABLE_FILE_FORMATS,
  FILE_TYPES_BY_SECTIONS_ASSET_DOC,
  OPERATIONAL_ASSETS_DOCUMENT_SECTIONS,
  PROCESS_ASSETS_STATUS,
} from '../constants';
import { ArtifactUploaderInput, MAX_SIZE } from 'domain/shared/artifact/input';
import { EnumDropdown, useFormContext } from 'framework/form';
import ProcessAssetNameSuggestionInput from '../shared/inputs/ProcessAssetNameSuggestionInput';
import { OfficeDropdown, EmployeeInput } from 'domain/shared/employee';
import { ProcessAssetsFormType } from '../types';

const ProcessAssetsFormFields = ({ isEditForm }: { isEditForm: boolean }) => {
  const { data = {} } = useFormContext();
  const { section } = data;
  const typeOptions = useMemo(() => FILE_TYPES_BY_SECTIONS_ASSET_DOC[section] || [], [section]);

  return (
    <>
      <MediumFormRow>
        <ProcessAssetNameSuggestionInput
          source="templateName"
          label="Template"
          placeholder="Template"
          disabled={isEditForm}
        />
        <EmployeeInput isInitialNameLoad label="Owner" source="owner" />
      </MediumFormRow>

      <FormRow colXl={4}>
        <EnumDropdown
          disabled
          options={OPERATIONAL_ASSETS_DOCUMENT_SECTIONS}
          label=""
          placeholder="Section"
          source="section"
        />
        <EnumDropdown options={typeOptions} label="" placeholder="Type" source="fileType" />

        <OfficeDropdown source="office" label="" placeholder="Office" />
      </FormRow>

      <BigFormRow>
        <ArtifactUploaderInput
          fileExtensions={AVAILABLE_FILE_FORMATS}
          isVisible={(formData: ProcessAssetsFormType) =>
            !isEditForm || formData?.status === PROCESS_ASSETS_STATUS.UNPUBLISHED
          }
          isNewDocumentStorage
          maximumSize={MAX_SIZE}
          maxElements={1}
          label=""
          source="paths"
        />
      </BigFormRow>
    </>
  );
};

export default ProcessAssetsFormFields;
